import { AlertsFormStateValues } from 'modules/campaigns/lib/schemas/alertSchema';
import { CampaignTypeFilter } from 'modules/domains/campaign';
import { useEffect } from 'react';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { AllMessageMediums, GraphQLAlertMetric } from '../../types';

type Props = {
  campaignType: CampaignTypeFilter;
  messageMedium: AllMessageMediums;
  metric: GraphQLAlertMetric;
};

export const useAlertForm = ({ metric, campaignType, messageMedium }: Props) => {
  const { metricName, valueType } = metric;

  const nameBase = `${messageMedium}-${campaignType}-${metricName}`;
  const statusName = `${nameBase}.status`;
  const thresholdName = `${nameBase}.${valueType}Threshold`;
  const frequencyName = `${nameBase}.frequency`;

  const [status, frequency] = useWatch({
    name: [statusName, frequencyName],
  });

  const { errors } = useFormState<AlertsFormStateValues>({ name: nameBase });
  const thresholdError = errors?.[nameBase]?.[`${valueType}Threshold`];
  const frequencyError = errors?.[nameBase]?.frequency;

  const { resetField } = useFormContext<AlertsFormStateValues>();

  useEffect(() => {
    if (!status && (thresholdError || frequencyError)) {
      resetField(thresholdName);
      resetField(frequencyName);
    }
  }, [status, thresholdError, frequencyError, thresholdName, frequencyName]);

  return {
    // RHF field values
    frequency,
    status,
    // RHF field names
    statusName,
    thresholdName,
    frequencyName,
    // RHF field errors
    thresholdError,
    frequencyError,
  };
};
